import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as InvoicesActions from '../../actions/invoices/actions-invoices';
import { Observable, of } from 'rxjs';
import { InvoicesService, sortInovoices } from '../../services/invoices/Invoices.service';
import { invoicesSelector, State } from '../../reducers';
import { select, Store } from '@ngrx/store';
import * as CoreActions from '@uxdf/direct-shared-lib';
import { InvoiceDownloadAPI } from '../../models/invoices/invoice-download-api';

@Injectable()
export class EffectsInvoices {

getInvoices$: Observable<any> = createEffect(() => {
  return this.actions$.pipe(
    ofType<InvoicesActions.GetInvoices>(InvoicesActions.GET_INVOICES),
    switchMap(() =>
      this.invoicesService.getInvoicesWithStatus().pipe(
        map((data: InvoiceDownloadAPI.IInvoicesResponsesWithStatus) => {
          data.searchResponseADDS.sort((a, b) => {
            if (a.creationDate > b.creationDate) {
              return -1;
            }
            if (a.creationDate < b.creationDate) {
              return 1;
            }
            return 0;
          });
          return new InvoicesActions.GetInvoicesSuccess(data.searchResponseADDS);
        }),
        catchError(error => {
          if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
            return of(new CoreActions.DirectUserRoleHasBeenChanged());
          }
          return of(new InvoicesActions.GetInvoicesError('pageSectionIsNotAvailable'));
        })
      )
    ),
    catchError(error => {
      if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
        return of(new CoreActions.DirectUserRoleHasBeenChanged());
      }

        this.store.dispatch(new InvoicesActions.GetInvoicesError(error.message));
        return this.getInvoices$;
      })
    )
  });

  sortInvoices: Observable<InvoicesActions.InvoicesAction> = createEffect(() => {
    return this.actions$.pipe(
      ofType<InvoicesActions.SortInvoicesInit>(InvoicesActions.SORT_INVOICES_INIT),
      map(action => action.payload),
      withLatestFrom(this.store.pipe(select(invoicesSelector))),
      switchMap(([direction, state]) =>
        sortInovoices(direction, state.invoices).pipe(
          switchMap(result => of(new InvoicesActions.SortInvoicesCompleted(result)))
        )
      )
    )
  });

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<State>,
    private readonly invoicesService: InvoicesService
  ) { }
}
